import React, {ReactNode} from "react";
import {motion, MotionStyle} from "framer-motion";

interface IProps {
    style?: MotionStyle;
    children: ReactNode;
    animationRef?: React.RefObject<HTMLDivElement | null>;
}

export const Animated: React.FC<IProps> = (props) => {
    return (
        <motion.div ref={props.animationRef} style={props.style}>
            {props.children}
        </motion.div>
    );
};
import React, {ReactNode} from "react";
import {motion, MotionStyle} from "framer-motion";

interface IProps {
    style?: MotionStyle;
    children: ReactNode;
    animationRef?: React.RefObject<HTMLDivElement | null>;
}

export const Animated: React.FC<IProps> = (props) => {
    return (
        <motion.div ref={props.animationRef} style={props.style}>
            {props.children}
        </motion.div>
    );
};
